export const isRefundMethodVisible = rmaInfo => {
  return rmaInfo?.orderInfo?.allowed_refund_methods?.length > 0 && Number(rmaInfo?.orderAmount?.remaining_amount) >= 0
}
